import { ACCESS_USERID_KEY } from '@/constant/config';
import { request } from '@/utils/request';
import Storage from '@/utils/Storage';

export const getMailList = (params?: { p_source: string }) => {
  return request(
    {
      url: `/mail/queryall`,
      params
    },
    {
      skipErrorHandle: true,
      isGetDataDirectly: true
    }
  );
};

//获取分页邮件列表
export const getMailPage = (params?: { p_source?: string; page: number }) => {
  return request(
    {
      url: `/mail/querybypage`,
      params
    },
    {
      skipErrorHandle: true,
      isGetDataDirectly: true
    }
  );
};

//获取单封邮件的数据
export const getOneMail = (params?: { p_rid: number }) => {
  const userid = Storage.getAccess(ACCESS_USERID_KEY);
  return request({
    url: `/mail/queryonemail`,
    method: 'post',
    params: { ...params, userid }
  });
};

//获取可领取邮件和未读邮件
export const getFetchMailList = () => {
  const userid = Storage.getAccess(ACCESS_USERID_KEY);
  return request({
    url: `/mail/queryfetchmail`,
    method: 'post',
    params: { userid }
  });
};

//读取邮件
export const readMail = (params: { p_rid: number[] }) => {
  const ids = params.p_rid.join(',');
  const userid = Storage.getAccess(ACCESS_USERID_KEY);
  return request({
    url: `/mail/readmail`,
    method: 'post',
    params: { userid, p_rid: ids }
  });
};

export const fetchMailAward = (params?: { p_rid: number }) => {
  return request({
    url: `/mail/fetchaward`,
    method: 'post',
    params
  });
};

export const deleteMail = (params?: { rid: number }) => {
  return request({
    url: `/mail/delete`,
    method: 'post',
    params
  });
};
